import { Box, SxProps, Tooltip, TooltipProps, styled } from "@mui/material";
import { CabComponentProps } from "../cabStyled";
import { ReactNode } from "react";


export interface ICabTooltip extends CabComponentProps<Record<string, never>> {
  title: TooltipProps['title'];
  children: ReactNode;
  placement?: TooltipProps['placement'];
  arrow?: TooltipProps['arrow'];
  wrapWithSpan?: boolean;
  disableInteractive?: TooltipProps['disableInteractive'];
  open?: TooltipProps["open"];
  onOpen?: TooltipProps["onOpen"];
  onClose?: TooltipProps["onClose"];
  componentsProps?: TooltipProps["slotProps"];
  slotProps?: TooltipProps["slotProps"];
  enterDelay?: TooltipProps["enterDelay"];
  enterNextDelay?: TooltipProps["enterNextDelay"];
  leaveDelay?: TooltipProps["leaveDelay"];
  spanSx?: SxProps;
}

export const CabTooltip = ({ 
  sx, title, children, placement, arrow, wrapWithSpan, open, onOpen, onClose, componentsProps, slotProps, enterDelay,
  enterNextDelay, leaveDelay, spanSx, disableInteractive
}: ICabTooltip) => {
  const tooltipSlotProps = (slotProps || componentsProps) as TooltipProps["slotProps"] & {
    tooltip?: { sx?: SxProps };
  } | undefined;
  const props = {
    sx,
    title,
    placement,
    arrow,
    open,
    onOpen,
    onClose,
    disableInteractive,
    enterDelay,
    enterNextDelay,
    leaveDelay
  };

  if (!title) {
    return <>{children}</>;
  }

  return (
    <StyledTooltip {...props}
      slotProps={{
        ...(tooltipSlotProps || {}),
        tooltip: {
          ...(tooltipSlotProps?.tooltip || {}),
          sx: {
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            ...(tooltipSlotProps?.tooltip?.sx || {}),
          }
        }
      }}
    >
      {!wrapWithSpan && !Array.isArray(children)
        ? <>{children}</>
        : <Box sx={spanSx}>{children}</Box>}
    </StyledTooltip>
  );
};


const StyledTooltip = styled(Tooltip, { label: 'StyledTooltip' })(() => ({
}));
